import { Link } from "react-router-dom";
import Shell from "./Shell";
import { SUPPORT_EMAIL } from "./constants";

function PrivacyPolicy() {
  return (
    <Shell>
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-xl font-bold text-gray-900">Privacy Policy</h2>
        <p className="text-gray-700 mt-4">
          SADWARE INCORPORATED built the Nightdrift app as a Commercial app. This SERVICE is provided by SADWARE INCORPORATED and is intended for use as is.
        </p>
        <p className="text-gray-700 mt-4">
          This page is used to inform visitors regarding our policies with the collection, use, and disclosure of information if anyone decided to use our Service.
        </p>
        <p className="text-gray-700 mt-4">
          The terms used in this Privacy Policy have the same meanings as in our Terms of Use, which are accessible at{" "}
          <Link to="/nightdrift/terms" className="text-blue-500 hover:text-blue-600">Nightdrift Terms of Use</Link>
          {" "}unless otherwise defined in this Privacy Policy.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Information Collection and Use</h2>
        <p className="text-gray-700 mt-4">
          Nightdrift is a sleep sounds app that plays audio on your device. It does not ask you to create an account, and it does not ask for your name, email address, or other contact details inside the app. Mixes, per-sound volumes, and sleep timer settings stay on your device. SADWARE INCORPORATED does not collect, store, or transmit that information.
        </p>
        <p className="text-gray-700 mt-4">
          Nightdrift Premium is purchased through Apple using StoreKit. Apple processes your Apple ID and payment information under Apple’s privacy policy. The app receives subscription status from StoreKit so it can unlock Nightdrift Premium on your device. SADWARE INCORPORATED does not receive your payment card number.
        </p>
        <p className="text-gray-700 mt-4">
          If you email us, we receive the address you write from and the contents of your message. We use that information to respond and to help with your request.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Log Data</h2>
        <p className="text-gray-700 mt-4">
          Nightdrift does not send usage logs, device identifiers, or your IP address to SADWARE INCORPORATED. The app does not include a SADWARE account or analytics service that collects personal information.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Cookies</h2>
        <p className="text-gray-700 mt-4">
          Nightdrift does not use cookies. These website pages do not set tracking cookies.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Service Providers</h2>
        <p className="text-gray-700 mt-4">
          Apple provides the App Store and StoreKit, which process the subscription. Apple’s use of information is described in Apple’s privacy policy. SADWARE INCORPORATED does not share personal information collected by Nightdrift with other companies, because the app does not collect it.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Security</h2>
        <p className="text-gray-700 mt-4">
          Sounds and settings remain on your device. No method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security. That includes email you choose to send us.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Links to Other Sites</h2>
        <p className="text-gray-700 mt-4">
          This Service may contain links to other sites, including the App Store and Apple’s policies. If you follow a third-party link, you will be directed to that site. These external sites are not operated by us. Review the privacy policy of those websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Children’s Privacy</h2>
        <p className="text-gray-700 mt-4">
          We do not knowingly collect personally identifiable information from children. Nightdrift does not request personal information from anyone using the app. If you believe a child has sent personal information to us by email, contact us and we will delete it.
        </p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Changes to This Privacy Policy</h2>
        <p className="text-gray-700 mt-4">
          We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.
        </p>
        <p className="text-gray-700 mt-4">This policy is effective as of 2026-10-18</p>

        <h2 className="text-xl font-bold text-gray-900 mt-6">Contact Us</h2>
        <p className="text-gray-700 mt-4">
          If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at{" "}
          <a href={"mailto:" + SUPPORT_EMAIL} className="text-blue-500 hover:text-blue-600">{SUPPORT_EMAIL}</a>.
        </p>
      </div>
    </Shell>
  );
}

export default PrivacyPolicy;
